import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

export function initSentry() {

    Sentry.init({
        dsn: "https://555d53b91f1e48158f4b28306bd42551@o1049280.ingest.sentry.io/6030586",
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });

}